import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import women from "../../images/login-women.png";
import LogoImage from "../../images/wosender.svg";
import NoIndex from "../NoIndex";
import "./AdminDashboard.css";
import MyContext from "../../MyContext";
import GoogleOneTap from "../Googleonetab";

const LoginPage = () => {
  const { baseUrl, config, config2 } = useContext(MyContext);
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [error, setError] = useState(null);
  const [MobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [MobileNumberError, setMobileNumberError] = useState("");
  const [Otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [step, setstep] = useState(1);
  const [OTPField, setOTPField] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const navigate = useNavigate();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [Lerror, setLerror] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [LoginScreen, setLoginScreen] = useState("LOGIN");


  const [User, setUser] = useState("no user");

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
function validateInputs() {
  if (MobileNumber.length !== 10) {
    toast.error("Invalid Mobile number");
  } else if (!password) {
    toast.error("Please enter your password");
  } else {
    LoginCall();
  }
}

  // Function to send OTP (step 1)
  const sendOtp = async () => {
    try {

      const BankData = {
        mobile: MobileNumber,
        password: password,
        step: "1", // step 1 for sending OTP
        otp: "",   // OTP is empty for step 1
        latitude: '',
        longitude: '',
      };

      // Send OTP request
      const response = await axios.post(
        `${baseUrl}/api/User/v1/userLogin`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage); // OTP sent successfully
        setLoginScreen("OTPVERIFICATION");
        setstep(2); // Move to step 2 (OTP verification)
        setOTPField(true); // Enable OTP input field
      } else if (response.data.responseCode === "01") {
        toast.error(response.data.responseMessage); // OTP sent successfully
        setError(true)
      } else {
        toast.error(response.data.responseMessage); // Handle any error message
      }
    } catch (error) {
      toast.error("Error sending OTP");
      console.error("Error sending OTP:", error);
    }
  };

  // Function to verify OTP (step 2)
  const verifyOtp = async () => {
    try {


      const BankData = {
        mobile: MobileNumber,
        password: password,
        step: "2", // step 2 for OTP verification
        otp: Otp.join(""), // User's entered OTP
        latitude: '',
        longitude: '',
      };

      // Verify OTP request
      const response = await axios.post(
        `${baseUrl}/api/User/v1/userLogin`,
        BankData,
        config2
      );


      if (response.data.responseCode === "00") {
        sessionStorage.setItem("user", JSON.stringify(response.data.response));
        setUser(true);
        console.log("responseData:", response.data.response.userid);
        // await verifyCredentials(responseData.response.userid);
        await subscriptionDetailsApi(response.data.response.userid);
        await allowedServicesAPI(response.data.response.userid);
        window.location.href = "/Dashboard";
      }
      else {
        toast.error(response.data.responseMessage)
      }
    } catch (error) {
      toast.error("Error verifying OTP");
      console.error("Error during OTP verification:", error);
    }
  };

  const allowedServicesAPI = async (userId) => {
    try {
      const requestBody = { userid: userId };
      const response = await axios.post(
        `${baseUrl}/api/User/getUserAccess`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        sessionStorage.setItem(
          "menuItems",
          JSON.stringify(response.data.response)
        );
      } else {
        console.log("Failed to get user access");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const subscriptionDetailsApi = async (userId) => {
    try {

      const responseBody = {
        userid: userId,
      };
      const response = await axios.post(
        `${baseUrl}/api/Entitlement/fetchSubscriptionDetails`,
        responseBody,
        config
      );
      if (response.data.responseCode === "00") {
        sessionStorage.setItem("power", "1");
        if (process.env.NODE_ENV == "development") {
          window.location.href = "/Dashboard";
        } else {
          window.location.href = "/Dashboard";
        }
      } else if (response.data.responseCode === "03") {
        if (process.env.NODE_ENV == "development") {
          window.location.href = "/Dashboard";
        } else {
          window.location.href = "/Dashboard";
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Main Login function
 const LoginCall = async () => {
  // Basic validation
  if (MobileNumber.length !== 10) {
    toast.error("Invalid Mobile number");
    return;
  }
  if (!password) {
    toast.error("Please enter your password");
    return;
  }

  try {
    const BankData = {
      mobile: MobileNumber,
      password: password,
      latitude: latitude || "",
      longitude: longitude || "",
    };

    const response = await axios.post(
      `${baseUrl}/api/User/v2.0/userLogin`,
      BankData,
      config2
    );

    if (response.data.responseCode === "00") {
      sessionStorage.setItem("user", JSON.stringify(response.data.response));
      setUser(true);
      await subscriptionDetailsApi(response.data.response.userid);
      await allowedServicesAPI(response.data.response.userid);
      window.location.href = "/Dashboard";
    } else {
      toast.error(response.data.responseMessage);
    }
  } catch (error) {
    toast.error("Error during login");
    console.error("Error during login:", error);
  }
};

  const ResendOtp = async (step) => {
    toast.info("Resending OTP...");

    try {

      const BankData = {
        mobile: MobileNumber,
        password: password,
        step: 1,
        otp: Otp.join(""),
        latitude: latitude,
        longitude: longitude,
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1/userLogin`,
        BankData,
        config2
      );
      if (step === "1") {
        toast.success(response.data.responseMessage);

        setUser(response.data.response);
        setstep(2);
        setOTPField(true);
      } else if (step === "2") {
        setUser(response.data.response);

        sessionStorage.setItem("power", "1");
        if (process.env.NODE_ENV == "development") {
          window.location.href = "/Dashboard";
        } else {
          window.location.href = "/Dashboard";
        }

      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error");
      console.error("Error updating Admin login:", error);
    }
  };

  const handleOtpChange = (element, index) => {
    if (isNaN(element.value)) return false;

    const newOtp = [...Otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    // Move to next input if value is entered
    if (element.value !== "" && element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  const handleKeyDown = (e, index) => {

    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtp = [...Otp];
      newOtp[index] = "";
      setOtp(newOtp);

      // Move to previous input if current is empty
      if (index > 0) {
        const prevInput = e.target.previousSibling;
        prevInput.focus();
      }
    }
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (err) => {
          setLerror(err.message);
        }
      );
    } else {
      setError("Geolocation is not supported by your browser");
    }
  }, []);

  const [ForgetNumber, setForgetNumber] = useState('');
  const [ForgetStep, setForgetStep] = useState(1);
  const [NewPassword, setNewPassword] = useState("");
  const [ConfirmNewPassword, setConfirmNewPassword] = useState("");
  const [ForgetOtp, setForgetOtp] = useState(["", "", "", "", "", ""]);

  const handleForgotOtpChange = (element, index) => {
    if (isNaN(Number(element.value))) return;

    const newOtp = [...ForgetOtp]; // Corrected the reference
    newOtp[index] = element.value;
    setForgetOtp(newOtp);

    // Move to next input if value is entered
    if (element.value !== "" && element.nextElementSibling) {
      element.nextElementSibling.focus();
    }

    // Move to previous input on backspace
    if (element.value === "" && element.previousElementSibling) {
      element.previousElementSibling.focus();
    }
  };
  const sendForgetOtp = async () => {
    try {
      const BankData = {
        mobile: ForgetNumber,
        newPassword: "",
        otp: "",
        step: "1", // Step 1: Send OTP
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1.0/forgetPassword`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setLoginScreen("OTPVERIFICATIONFORGET");
        setForgetStep(2); // Move to OTP Verification step
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error sending OTP");
      console.error("Error sending OTP:", error);
    }
  };

  const verifyForgetOtp = async () => {
    try {

      const BankData = {
        mobile: ForgetNumber,
        newPassword: "",
        otp: ForgetOtp.join(""),
        step: "2", // Step 2: Verify OTP
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1.0/forgetPassword`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setLoginScreen("RESET_PASSWORD"); // Move to new password screen
        setForgetStep(3);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error verifying OTP");
      console.error("Error verifying OTP:", error);
    }
  };

  const resetPassword = async () => {
    if (NewPassword !== ConfirmNewPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {

      const BankData = {
        mobile: ForgetNumber,
        newPassword: NewPassword,
        otp: ForgetOtp.join(""),
        step: "3", // Step 3: Reset Password
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1.0/forgetPassword`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success("Password reset successfully!");
        setLoginScreen("LOGIN"); // Redirect to login page
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error resetting password");
      console.error("Error resetting password:", error);
    }
  };

  function ForgotPassWord() {
    setLoginScreen("FORGOTPASSWORD")
  }

    const registerUserAfterGoogleLogin = async (googleUser) => {

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU="
    );

    const payload = {
      userid: "1",
      clientName: googleUser.name,
      password: googleUser.email,
      clientNumber: googleUser.email,
      userType: "1",
      onboardingType: "2",
      onboardedBy: "1",
      clientId: "1",
      billingName: googleUser.name,
      allowedIp: "",
      firstName: googleUser.firstName,
      lastName: googleUser.lastName,
    };

    const response = await fetch(`${baseUrl}/api/User/register`,{
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(payload),
    });

    // console.log(" HTTP STATUS:", response.status);

    const result = await response.json();
    // console.log(" REGISTER API RESPONSE:", result);

    return result;
  };

  const handleGoogleResponse = async (response) => {
    try {
      if (!response?.credential) return;

      const base64Url = response.credential.split(".")[1];
      const decodedData = JSON.parse(
        atob(base64Url.replace(/-/g, "+").replace(/_/g, "/"))
      );

      const [firstName, ...rest] = decodedData.name.split(" ");
      const lastName = rest.join(" ");

      const googleUser = {
        name: decodedData.name,
        email: decodedData.email,
        firstName,
        lastName,
      };

      const registerResult = await registerUserAfterGoogleLogin(googleUser);

      if (registerResult?.responseCode !== "00") {
        toast.error(registerResult?.responseMessage || "Registration failed");
        return;
      }
      sessionStorage.setItem("power", "1");
      const userData = registerResult.response;
      // sessionStorage.setItem("power", "1");

      sessionStorage.setItem("user", JSON.stringify(userData));

      toast.success("Login successful");

      setTimeout(() => {
        window.location.href = "/Dashboard";
      }, 1000);
    } catch (err) {
      console.error("GOOGLE LOGIN ERROR", err);
      toast.error("Something went wrong");
    }
  };

  return (
    <div className="anlook-container">
      <NoIndex />
      <ToastContainer position="top-center" />
      <div className="anlook-card">
        <div className="anlook-form-section">
          <div className="justify-content-start text-start d-flex flex-column">
            <div className="anlook-logo text-start d-flex justify-content-start">
              <img src={LogoImage} height={40} alt="Logo" />
            </div>

            {/*  Login Flow */}
            {LoginScreen === "LOGIN" ? (
              <>
                <h2 className="anlook-welcome-text">Welcome to WoSender</h2>
                <h1 className="anlook-title">Get started with your phone number</h1>
                <form className="anlook-form">
                  <div className="anlook-input-group">
                    <select className="anlook-country-code">
                      <option value="+91">+91</option>
                    </select>
                    <input
                      type="tel"
                      className={`anlook-input ${error ? "invalid" : ""}`}
                      placeholder="Phone number"
                      value={MobileNumber}
                      onChange={(e) => setMobileNumber(e.target.value)}
                    />
                  </div>
                  <div className="anlook-input-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="anlook-input"
                      placeholder="Enter Your Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <div className="anlook-show-password-container">
                    <input
                      type="checkbox"
                      id="showPassword"
                      checked={showPassword}
                      onChange={togglePasswordVisibility}
                      className="anlook-checkbox"
                    />
                    <label htmlFor="showPassword" className="anlook-show-password-label">
                      Show Password
                    </label>
                  </div>
                  <button type="button" onClick={validateInputs} className="anlook-continue-button">
                    Continue
                  </button>
                  <button type="button" className="anlook-forget-password-button" onClick={() => setLoginScreen("FORGOTPASSWORD")}>
                    Forget password
                  </button>
                </form>

                <div className="mt-1">
            <GoogleOneTap onSuccess={handleGoogleResponse} />
          </div>
              </>

              
            ) : LoginScreen === "OTPVERIFICATION" ? (
              <>
                <h2 className="anlook-welcome-text">Welcome to WoSender</h2>
                <h1 className="anlook-title">Secure Your Access with a Quick OTP Verification!</h1>
                <form className="anlook-form">
                  <div className="anlook-otp-input-container">
                    {Otp.map((data, index) => (
                      <input
                        className="anlook-otp-input"
                        type="text"
                        name="otp"
                        maxLength="1"
                        key={index}
                        value={data}
                        onChange={(e) => handleOtpChange(e.target, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                      />
                    ))}
                  </div>
                  <button type="button" onClick={LoginCall} className="anlook-continue-button">
                    Continue
                  </button>
                  <button type="button" onClick={ResendOtp} className="anlook-resend-button">
                    Re-send OTP
                  </button>
                </form>
              </>
            ) : null}

            {/* ✅ Forgot Password Flow */}
            {LoginScreen === "FORGOTPASSWORD" ? (
              <>
                <h1>Forgot Password?</h1>
                <form className="anlook-form">
                  <div className="anlook-input-group">
                    <select className="anlook-country-code">
                      <option value="+91">+91</option>
                    </select>
                    <input
                      type="tel"
                      className={`anlook-input ${error ? "invalid" : ""}`}
                      placeholder="Phone number"
                      value={ForgetNumber}
                      onChange={(e) => setForgetNumber(e.target.value)}
                    />
                  </div>
                  <button type="button" onClick={sendForgetOtp} className="anlook-continue-button">
                    Continue
                  </button>
                </form>
              </>
            ) : LoginScreen === "OTPVERIFICATIONFORGET" ? (
              <>
                <h2>OTP Verification</h2>
                <form className="anlook-form">
                  <div className="anlook-otp-input-container">
                    {ForgetOtp.map((data, index) => (
                      <input
                        className="anlook-otp-input"
                        type="text"
                        name="otp"
                        maxLength="1"
                        key={index}
                        value={data}
                        onChange={(e) => handleForgotOtpChange(e.target, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                      />
                    ))}
                  </div>
                  <button type="button" onClick={verifyForgetOtp} className="anlook-continue-button">
                    Continue
                  </button>
                </form>
              </>
            ) : LoginScreen === "RESET_PASSWORD" ? (
              <>
                <h2>Reset Password</h2>
                <form className="anlook-form">
                  <div className="anlook-input-group">
                    <input
                      type="password"
                      className="anlook-input"
                      placeholder="New Password"
                      value={NewPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                  </div>
                  <div className="anlook-input-group">
                    <input
                      type="password"
                      className="anlook-input"
                      placeholder="Confirm New Password"
                      value={ConfirmNewPassword}
                      onChange={(e) => setConfirmNewPassword(e.target.value)}
                    />
                  </div>
                  <button type="button" onClick={resetPassword} className="anlook-continue-button">
                    Reset Password
                  </button>
                </form>
              </>
            ) : null}
          </div>
        </div>
      </div>
      <div className="anlook-image-section">
        <img src={women} alt="Business woman using smartphone" className="anlook-image" />
      </div>
    </div>
  );

};

export default LoginPage;